import useService from "./useService";

export const EDIT_MEDICALLY_COMPLETE_CASE = "casemanager.edit_medically_complete_case";

export default function useMedicalCompleteLock() {
  const currentUserService = useService("current-user-service");
  const permissions = currentUserService?.userRoles?.permissions ?? [];
  const canEditMedicallyCompleteCase = permissions.includes(EDIT_MEDICALLY_COMPLETE_CASE);

  const caseLocked = (caseObj) =>
    Boolean(caseObj?.medicalStatusLocked) && !canEditMedicallyCompleteCase;

  return {
    canEditMedicallyCompleteCase,

    isCaseStatusLocked: caseLocked,

    isAppointmentLocked: caseLocked,

    isProviderRecordLocked: (proCliData) =>
      Boolean(proCliData?.caseMedicallyComplete) && !canEditMedicallyCompleteCase,
  };
}
